export const normalizeForSearch = (value: string): string => value.trim().toLowerCase();

export const searchByName = <T extends { name: string }>(items: T[], query: string): T[] => {
  const normalized = normalizeForSearch(query);
  if (!normalized) return items;
  return items.filter((item) => item.name.toLowerCase().includes(normalized));
};
